'use strict';

angular.module('app', ['ui.router', 'ngTouch', 'ngAnimate', 'angular-loading-bar', 'pc035860.scrollWatch']);
'use strict';

function fluxioHeaderReveal() {
  return {
    restrict: 'A',
    require: 'fluxioHeaderReveal',
    scope: {
      revealOn: '='
    },
    bindToController: true,
    link: function link($scope, $element, $attrs, hrCtrl) {
      $element.ready(function () {
        console.log("HR Ready for anim", $element);
        $scope.$apply(function () {
          hrCtrl.init();
        });
      });
    },
    controller: function controller($scope, $element, $animate) {
      var that = this;
      that.init = function () {
        that.el = $($element);
        that.initHeight = that.el.height();
        console.log("Current el height", $($element).height());
        console.log("Reveal", that.revealOn);
      };

      var revealWatch = $scope.$watch(function () {
        return that.revealOn;
      }, function (nv, ov) {
        if (nv !== ov) {
          console.log("header reveal changed!", nv);
          if (nv) {
            $animate.addClass(that.el, 'reveal');
          }
        }
      });

      $scope.$on('$destroy', function () {
        revealWatch = null;
      });
    },
    controllerAs: 'hrCtrl'
  };
}

angular.module('app').directive('fluxioHeaderReveal', fluxioHeaderReveal).animation('.headerReveal', function ($window) {
  return {
    beforeAddClass: function beforeAddClass(element, className, done) {
      if (className === 'reveal') {
        console.log("ANIM REVEAL ADDED");
        var el = $(element),
            initHeight = el.height(),
            initWidth = el.width(),
            idealHeight = initWidth * 0.45;

        el.css({
          height: initHeight
        }).transition({
          height: idealHeight
        }, 1200, 'easeInOutCubic', function () {
          done();
        });
      } else {
        done();
      }
    },
    beforeRemoveClass: function beforeRemoveClass(element, className, done) {
      if (className === 'reveal') {
        console.log("ANIM REVEAL REMOVE");
        var el = $(element),
            initHeight = el.height(),
            idealHeight = $($window).height();

        el.css({
          height: initHeight
        }).transition({
          height: '100%'
        }, 1200, 'easeInOutCubic', function () {
          done();
        });
      } else {
        done();
      }
    }
  };
});
'use strict';

angular.module('app').controller('pageController', function ($state) {
  console.log("page controller online", $state.current);
  var that = this;
  that.isHome = function () {
    console.log("IS HOME?", $state.is('holding'));
    return $state.is('holding');
  };
});
'use strict';

angular.module('app').component('screensave', {
  templateUrl: 'app/components/screensaver/screensave.html',
  controller: function controller() {}
}).directive('fluxioLogoScreensave', function ($timeout) {
  return {
    template: '<svg ng-class="{\'loaded\': ssCtrl.loaded}" id="ss"></svg>',
    require: 'fluxioLogoScreensave',
    scope: { src: '=?' },
    bindToController: true,
    controller: function controller($scope) {
      var that = this;
      that.snap = {};
      that.loaded = false;

      //var goofilter = '<filter id="goo-hd"><feGaussianBlur  in="SourceGraphic" stdDeviation="9" result="blur" \/><feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -7" result="goo" \/><feComposite in="SourceGraphic" in2="goo" operator="atop" \/><\/filter>';
      var goofilterBig = '<filter id="goo-hd-big"><feGaussianBlur id="gaussb" in="SourceGraphic" stdDeviation="18" result="blur" \/><feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 60 -12" result="goo" \/><feComposite in="SourceGraphic" in2="goo" operator="atop" \/><\/filter>';

      that.init = function () {
        that.snap = Snap("#ss");
        console.log("SNAP ATTR INIT", that.snap.getBBox(), that.snap);
        that.snap.select('defs').append(Snap.parse(goofilterBig));

        Snap.load("app/components/screensaver/globe-grid.svg", function (f) {
          that.svgFile = f;
          that.dissect(f);
          that.doBoids(f);
          $timeout(function () {
            that.loaded = true;
          }, 100);
        });
      };

      that.doBoids = function (f) {

        var x = f.select('#o');

        that.svg = f.select('svg');
        // Set viewbox to element vb
        that.svgbox = that.svg.attr('viewBox');

        that.globe = f.select('#globe');
        that.globebox = that.globe.getBBox();

        var omask = that.snap.circle(that.globebox.cx, that.globebox.cy, that.globebox.width / 2).attr({ stroke: 'silver', 'strokeWidth': 1, fill: 'silver' });
        var outerOmask = that.snap.circle(that.globebox.cx, that.globebox.cy, that.globebox.width / 2).attr({ stroke: 'silver', 'strokeWidth': 1, fill: 'silver' });

        that.bg = that.snap.circle(that.globebox.cx, that.globebox.cy, that.globebox.width / 2 + 10).attr({ stroke: 'rgb(221,221,221)', 'strokeWidth': 1, fill: 'rgb(221,221,221)' });

        that.snap.append(that.globe);

        var swarm;
        that.swarm = new Swarm(that.snap, that.globebox, that.globebox, that.globebox);

        that.swarm2 = new Swarm(that.snap, that.globebox, that.globebox, that.globebox);

        that.swarm3 = new Swarm(that.snap, that.svgbox, that.svgbox, that.svgbox);

        function repeatOften() {
          that.swarm.animate();
          that.swarm2.animate();
          window.requestAnimationFrame(repeatOften);
        }

        that.swarm3.clear();
        that.swarm3.createBoidDistributed(100, 'rgba(250,249,249,0.6)', 10, 4, 3000);

        that.swarm.clear();
        that.swarm.createBoidDistributed(450, 'rgb(247,147,30)', 2, 6, 1000);

        that.swarm2.clear();
        that.swarm2.createBoidDistributed(300, 'rgba(250,249,249,0.8)', 1.8, 12, 1000);

        that.boidsGroup = that.snap.group();
        that.boids = that.swarm.getBoids();

        for (var i = 0; i < that.boids.length; i++) {
          that.boidsGroup.add(that.boids[i].dot);
        }

        that.boidsGroup2 = that.snap.group();
        that.boids2 = that.swarm2.getBoids();
        for (var i = 0; i < that.boids2.length; i++) {
          that.boidsGroup2.add(that.boids2[i].dot);
        }
        that.boidsGroup2.attr({ filter: 'url(\'#goo-hd-big\')' });

        that.boidsGroup.attr({ mask: omask });
        that.boidsGroup2.attr({ mask: outerOmask });

        window.requestAnimationFrame(repeatOften);
      };

      that.dissect = function (f) {
        // Note that we traversre and change attr before SVG
        // is even added to the page
        that.svg = f.select('svg');
        // Set viewbox to element vb
        var svgbox = that.svg.attr('viewBox');
        that.svgbox = that.svg.attr('viewBox');
        console.log("svgbox", svgbox);
        that.snap.attr({ viewBox: svgbox.vb });

        // Selection..
        that.globe = f.selectAll("#globe");
      };

      $scope.$on('$destroy', function () {
        console.log("logo scope destoyred");
        that.snap = null;
        that.swarm = null;
        that.swarm2 = null;
        that.swarm3 = null;
        that.boids = null;
        that.boids2 = null;
        that.boids3 = null;
        that.boidsGroup = null;
        that.boidsGroup2 = null;
      });
    },
    controllerAs: 'ssCtrl',
    link: function link($scope, $element, $attrs, ssCtrl) {
      $element.ready(function () {
        console.log("SVG Ready for anim", $element);
        $scope.$apply(function () {
          ssCtrl.init();
        });
      });
    }
  };
});
/**
 * Created by Cosy on 02/10/2016.
 */
/*

 .factory('fluxioCartItem', function ($rootScope, $log, productSource) {

 var item = function (product) {
 //console.log("new item!", product);
 var that = this;
 that.setProduct(product);
 that.setId(product.id);
 that.setPrice(product.price);
 that.setQuantity(product.qty);
 productSource.getProductDataById(product.id).then(function(fullProduct) {
 // after all the data is fetched set product to full product dataset
 //console.log("Cart:Product data set updated", fullProduct);
 that.setProduct(fullProduct);
 });
 };

 item.prototype.setProduct = function(p){
 if (p.id)  this._product = p;
 else {
 $log.error('An ID must be provided');
 }
 };

 item.prototype.getProduct = function() {
 return this._product;
 };

 item.prototype.setId = function(id) {
 this.id = id;
 };

 item.prototype.getId = function(){
 return this.id;
 };

 item.prototype.setQuantity = function(quantity, relative){
 var quantityInt = parseInt(quantity);
 if (quantityInt % 1 === 0){
 if (relative === true){
 this.qty  += quantityInt;
 } else {
 this.qty = quantityInt;
 }
 if (this.qty < 1) this.qty = 1;

 } else {
 this.qty = 1;
 $log.info('Quantity must be an integer and was defaulted to 1');
 }
 };

 item.prototype.setPrice = function(price) {
 this.price = price;
 };

 item.prototype.getPrice = function(){
 return parseFloat(this.price);
 };

 item.prototype.getQuantity = function(){
 return this.qty;
 };

 item.prototype.getTotal = function(){
 //console.log("Get item total", this.getQuantity(), this.getPrice(), parseFloat(this.getQuantity() * this.getPrice()) );
 return +parseFloat(this.getQuantity() * this.getPrice()).toFixed(2);
 };

 item.prototype.toObject = function() {
 return {
 id: this.getId(),
 product: this.getProduct(),
 quantity: this.getQuantity(),
 total: this.getTotal()
 }
 };

 return item;
 });







 */
"use strict";
'use strict';

/*class FluxioLogoController {
  constructor() {
    this.text = 'My brand new component!';
  }
}*/

angular.module('app').component('fluxioLogo', {
  templateUrl: 'app/components/fluxioLogo/fluxioLogo.html',
  controller: function controller($scope) {
    var that = this;
    that.reveal = false;

    that.revealContent = function () {
      console.log("Reveal click...");
      that.reveal = true;
    };

    $scope.$on('revealHeader', function ($evt, active, locals) {
      console.log("Scroll:Reveal event", active);
      if (active) {
        that.reveal = true;
      } else {
        that.reveal = false;
      }
    });

    that.sectorsLeft = [{
      title: 'E-Commerce',
      clients: [{ name: 'The Gin Box Shop', link: 'https://theginboxshop.co.uk' }, { name: 'Social Pantry Delivered', link: 'https://socialpantry.co.uk/deliveries' }]
    }, {
      title: 'Hospitality',
      clients: [{ name: 'The Poet', link: 'http://thepoetatmatfield.co.uk/' }, { name: 'Kitchen of Kent', link: 'http://kitchenofkent.co.uk/' }, { name: 'The Ragged Trousers', link: 'http://theragged.co.uk/' }, { name: 'Eden Apartments, Chamonix', link: 'http://www.edenapartments.co.uk/' }]
    }];
    that.sectorsRight = [{
      title: 'Entertainment',
      clients: [{ name: 'Songs About Animals', link: 'http://songsaboutanimals.co.uk/album' }, { name: 'Unfest', link: 'http://unfest.org' }]
    }, {
      title: 'Portfolio',
      clients: [{ name: 'Bill Talbot', link: 'http://billtalbot.com' }]
    }];

    that.fields_design = ['Brand design', 'Print & Stationary', 'Signage & Advertising', 'Packaging design', 'Web & Mobile App design', 'User experience design', 'Content design'];

    that.fields_technology = ['Websites', 'Interface development', 'Web & Mobile App Development', 'E-Commerce systems', 'Content management systems', 'Customer management systems', 'RESTful API\'s', 'Prototyping', 'Video tutorials'];

    that.fields_environments = ['Adobe Illustrator', 'Adobe Photoshop', 'Webstorm/Phpstorm', 'Eclipse'];

    that.fields_frameworks = ['Magento', 'Drupal', 'Wordpress', 'Node JS', 'Angular JS', 'Cordova/Ionic', 'jQuery', 'SASS'];

    that.logos = ['Gin-Box-Shop.svg', 'The-Sussex-Arms.svg', 'Unfest.svg', 'The-Poet.svg', 'Shoyswell-Cottage.svg', 'Kitchen-Of-Kent.svg', 'The-Bull-at-Brenchley.svg', 'The-Little-Bull.svg', 'Lasham-Regionals-Gliding-Club.svg'];
  }
}).directive('fluxioLogoSvg', function () {
  return {
    templateUrl: 'app/components/fluxioLogo/fluxioLogoSvg.html',
    require: 'fluxioLogoSvg',
    scope: { src: '=?' },
    bindToController: true,
    controller: function controller($scope, $timeout, $window) {
      var that = this;
      that.snap = {};
      that.loaded = false;

      var goofilter = '<filter id="goo-hd"><feGaussianBlur id="gauss" in="SourceGraphic" stdDeviation="9" result="blur" \/><feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 20 -7" result="goo" \/><feComposite in="SourceGraphic" in2="goo" operator="atop" \/><\/filter>';
      var goofilterClouds = '<filter id="goo-hd-clouds"><feGaussianBlur id="gaussLetters" in="SourceGraphic" stdDeviation="5" result="blur" \/><feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 10 -2" result="goo" \/><feComposite in="SourceGraphic" in2="goo" operator="atop" \/><\/filter>';

      that.init = function () {
        //get svg element and snapify
        that.snap = Snap("#logo");
        //Append filter to snap svg
        that.snap.select('defs').append(Snap.parse(goofilterClouds));

        Snap.load("app/components/fluxioLogo/fluxio-logo-svg.svg", function (f) {
          that.svgFile = f;
          that.importSVG(f);
          if ($($window).width() > 660) {
            that.doBoids(f);
          }
          that.snap.append(that.letters);
          $timeout(function () {
            that.loaded = true;
          }, 100);
        });
      };

      that.doBoids = function (f) {
        that.svg = f.select('svg');
        // Set viewbox to element vb
        that.svgbox = that.svg.attr('viewBox');

        //get globe and place over O
        var globe = f.select('#globe');
        globe.attr({
          cx: that.obox.cx,
          cy: that.obox.cy
        });

        //Create masks & background from O centre
        var omask = that.snap.circle(that.obox.cx, that.obox.cy, that.obox.width / 2).attr({ stroke: 'silver', 'strokeWidth': 1, fill: 'silver' });
        var outerOmask = that.snap.circle(that.obox.cx, that.obox.cy, that.obox.width / 2).attr({ stroke: 'silver', 'strokeWidth': 1, fill: 'silver' });
        that.bg = that.snap.circle(that.obox.cx, that.obox.cy, that.obox.width / 2).attr({ stroke: 'rgb(221,221,221)', 'strokeWidth': 1, fill: 'rgb(221,221,221)' });

        // Create 2 swarms (land/clouds)
        that.swarm = new Swarm(that.snap, that.obox, that.obox, that.obox);
        that.swarm2 = new Swarm(that.snap, that.obox, that.obox, that.obox);

        //Anim function
        function repeatOften() {
          that.swarm.animate();
          that.swarm2.animate();
          // Do whatever
          window.requestAnimationFrame(repeatOften);
        }

        //For each swarm, create boids
        that.swarm.clear();
        that.swarm.createBoidDistributed(350, 'rgb(102,102,102)', 1.5, 2, 250);

        that.swarm2.clear();
        that.swarm2.createBoidDistributed(200, 'rgba(237,239,239,0.8)', 1.2, 5, 200);
        //swarm2.createGroups(100, 'rgba(237,239,239,0.8)', 2, 4, 5, 150);//0.3
        //swarm2.createBoid(500, 'rgba(237,239,239,0.8)', 2, 4);//0.4

        //Create group and add boids to that group
        that.boidsGroup = that.snap.group();
        that.boids = that.swarm.getBoids();
        for (var i = 0; i < that.boids.length; i++) {
          that.boidsGroup.add(that.boids[i].dot);
        }

        that.boidsGroup2 = that.snap.group();
        that.boids2 = that.swarm2.getBoids();
        for (var i = 0; i < that.boids2.length; i++) {
          that.boidsGroup2.add(that.boids2[i].dot);
        }
        //Apply goo filter to cloud group
        that.boidsGroup2.attr({ filter: 'url(\'#goo-hd-clouds\')' });

        // Apply masks to group
        that.boidsGroup.attr({ mask: omask });
        that.boidsGroup2.attr({ mask: outerOmask });
        //Append globe on top
        that.snap.append(globe);
        //Kick off anim
        window.requestAnimationFrame(repeatOften);
      };

      that.importSVG = function (f) {
        // Note that we traversre and change attr before SVG
        // is even added to the page
        that.svg = f.select('svg');
        // Set viewbox to element vb
        var svgbox = that.svg.attr('viewBox');
        that.svgbox = that.svg.attr('viewBox');
        that.snap.attr({ viewBox: svgbox.vb });
        //Apply same viewbox as SVG to snap view

        // Selection..
        that.dots = f.selectAll(".dot");
        that.letters = f.selectAll('.letter');
        var o = f.select('#o');
        that.obox = o.getBBox();
      };

      $scope.$on('$destroy', function () {
        console.log("logo scope destoyred");
        //On destory - nulify snap object
        that.snap = null;
        that.swarm = null;
        that.boids = null;
        that.boids2 = null;
        that.boidsGroup = null;
        that.boidsGroup2 = null;
      });
    },
    controllerAs: 'logoCtrl',
    link: function link($scope, $element, $attrs, logoCtrl) {
      $element.ready(function () {
        $scope.$apply(function () {
          logoCtrl.init();
        });
      });
    }
  };
});
'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FluxioHoldController = function FluxioHoldController() {
  _classCallCheck(this, FluxioHoldController);

  this.text = 'My brand new component!';
};

angular.module('app').component('fluxioHold', {
  templateUrl: 'app/components/fluxioHold/fluxioHold.html',
  controller: FluxioHoldController
});
"use strict";

/**
 * Created by Cosy on 02/10/2016.
 */
/* Boid prototype */

function Boid(swarm, col, speed, size, scatterXI, scatterYI) {

  //this.x = Math.random() * swarm.width;
  //this.y = Math.random() * swarm.height;
  var scatterX, scatterY;
  if (!_.isUndefined(scatterXI)) {
    scatterX = scatterXI;
    scatterY = scatterYI;
  } else {
    scatterX = 0;
    scatterY = 0;
  }

  this.x = swarm.centreX + scatterX;
  this.y = swarm.centreY + scatterY;
  this.heading = Math.random() * 2 * Math.PI - Math.PI;
  var snap = swarm.snap;
  if (!_.isUndefined(size)) {
    this.dot = snap.circle(swarm.centreX + scatterX, swarm.centreY + scatterY, size - 1);
  } else {
    this.dot = snap.circle(swarm.centreX + scatterX, swarm.centreY + scatterY, 3);
  }
  //this.dot = snap.circle(swarm.centreX, swarm.centreY, 3);
  //console.log("Dot is", this.dot.attr('cx'));
  if (!_.isUndefined(col)) {
    this.dot.attr({
      fill: col,
      "fill-opacity": 1
    });
  } else {
    this.dot.attr({
      fill: 'rgb(120,150,157)',
      "fill-opacity": 1
    });
  }

  if (!_.isUndefined(speed)) {
    this.speed = speed;
  }

  if (!_.isUndefined(size)) {
    this.radius = size + 1;
  }
}

Boid.prototype.radius = 4;
Boid.prototype.speed = 0.3;
Boid.prototype.radialSpeed = Math.PI / 45;
Boid.prototype.vision = 60;

/*
godd for mystical ball with the right blur/goo filter
 Boid.prototype.radius = 9;
 Boid.prototype.speed = 0.5;
 Boid.prototype.radialSpeed = Math.PI / 60;
 Boid.prototype.vision = 50;
 */

Boid.prototype.draw = function (swarm) {
  var snap = swarm.snap;
  var that = this;
  //that.dot.transform('t'+ this.x + ','+ this.y);
  //that.dot.transform('t'+ this.x + ','+ this.y);
  that.dot.attr({ cx: this.x, cy: this.y });

  //that.dot.animate({transform: 't'+ this.x + ','+ this.y}, 10, mina.easeinout);
  /*
  var pointLen = this.radius * 2.5;
  ctx.fillStyle = 'pink';
  ctx.beginPath();
  ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
  ctx.fill();
  /*ctx.beginPath();
  ctx.moveTo(this.x + Math.cos(this.heading + Math.PI / 2) * this.radius,
    this.y + Math.sin(this.heading + Math.PI / 2) * this.radius);*/
  /*ctx.lineTo(this.x + Math.cos(this.heading + Math.PI) * pointLen,
    this.y + Math.sin(this.heading + Math.PI) * pointLen);
  ctx.lineTo(this.x + Math.cos(this.heading - Math.PI / 2) * this.radius,
    this.y + Math.sin(this.heading - Math.PI / 2) * this.radius);*/
  //ctx.fill();*/
};

Boid.prototype.distance = function (boid, width, height) {
  var x0 = Math.min(this.x, boid.x),
      x1 = Math.max(this.x, boid.x);
  var y0 = Math.min(this.y, boid.y),
      y1 = Math.max(this.y, boid.y);
  var dx = Math.min(x1 - x0, x0 + width - x1);
  var dy = Math.min(y1 - y0, y0 + height - y1);
  return Math.sqrt(dx * dx + dy * dy);
};

Boid.prototype.getNeighbors = function (swarm) {
  var w = swarm.width,
      h = swarm.height;
  var neighbors = [];
  for (var i = 0; i < swarm.boids.length; i++) {
    var boid = swarm.boids[i];
    if (this !== boid && this.distance(boid, w, h) < this.vision) {
      neighbors.push(boid);
    }
  }
  return neighbors;
};

Boid.wrap = function (value) {
  var min, max;
  if (arguments.length === 2) {
    min = 0;
    max = arguments[1];
  } else if (arguments.length === 3) {
    min = arguments[1];
    max = arguments[2];
  } else {
    throw new Error('wrong number of arguments');
  }
  while (value >= max) {
    value -= max - min;
  }while (value < min) {
    value += max - min;
  }return value;
};

Boid.clamp = function (value, limit) {
  return Math.min(limit, Math.max(-limit, value));
};

Boid.meanAngle = function () {
  var sumx = 0,
      sumy = 0,
      len = arguments.length;
  for (var i = 0; i < len; i++) {
    sumx += Math.cos(arguments[i]);
    sumy += Math.sin(arguments[i]);
  }
  return Math.atan2(sumy / len, sumx / len);
};

Boid.prototype.step = function (swarm) {
  var w = swarm.width,
      h = swarm.height;
  var neighbors = this.getNeighbors(swarm);
  if (neighbors.length > 0) {
    var meanhx = 0,
        meanhy = 0;
    var meanx = 0,
        meany = 0;
    var mindist = this.radius * 2,
        min = null;
    for (var i = 0; i < neighbors.length; i++) {
      var boid = neighbors[i];
      meanhx += Math.cos(boid.heading);
      meanhy += Math.sin(boid.heading);
      meanx += boid.x;
      meany += boid.y;
      var dist = this.distance(boid, w, h);
      if (dist < mindist) {
        mindist = dist;
        min = boid;
      }
    }
    meanhx /= neighbors.length;
    meanhy /= neighbors.length;
    meanx /= neighbors.length;
    meany /= neighbors.length;

    var target;
    if (min) {
      // Keep away!
      target = Math.atan2(this.y - min.y, this.x - min.x);
    } else {
      // Match heading and move towards center
      var meanh = Math.atan2(meanhy, meanhx);
      var center = Math.atan2(meany - this.y, meanx - this.x);
      target = Boid.meanAngle(meanh, meanh, meanh, center);
    }

    // Move in this direction
    var delta = Boid.wrap(target - this.heading, -Math.PI, Math.PI);
    delta = Boid.clamp(delta, this.radialSpeed);
    this.heading = Boid.wrap(this.heading + delta, -Math.PI, Math.PI);
  }

  this.move(swarm);
};

Boid.prototype.move = function (swarm) {
  var padding = swarm.padding;
  var width = swarm.width,
      height = swarm.height;
  this.x = Boid.wrap(this.x + Math.cos(this.heading) * this.speed, -padding + swarm.offsetx + 10, width + padding * 2 + swarm.offsetx - 10);
  this.y = Boid.wrap(this.y + Math.sin(this.heading) * this.speed, -padding + swarm.offsety + 10, height + padding * 2 + swarm.offsety - 10);
};

/* Swam prototype. */

function Swarm(snap, bounds, centreBBox, offset) {
  this.snap = snap;
  this.bounds = bounds;
  this.offset = offset;
  console.log("box", centreBBox, bounds);
  this.centreX = centreBBox.cx;
  this.centreY = centreBBox.cy;
  this.boids = [];
  var swarm = this;
  this.animate = function () {
    Swarm.step(swarm);
  };
  this.padding = 8;
}

Swarm.prototype.createBoid = function (n, col, speed, size) {
  for (var i = 0; i < (n || 1); i++) {
    this.boids.push(new Boid(this, col, speed, size));
  }
};

Swarm.prototype.createGroups = function (n, col, speed, size, numgroups, scatterWidth) {
  var scatters = getRandomNumbers(numgroups * 2, -(scatterWidth / 2), scatterWidth / 2);
  console.log("scatters", scatters);
  for (var i = 0; i < numgroups; i++) {
    for (var x = 0; x < (n || 1); x++) {
      this.boids.push(new Boid(this, col, speed, size, scatters[i + 1], scatters[(i + 1) * 2 - 1]));
    }
  }
};

Swarm.prototype.createBoidDistributed = function (n, col, speed, size, scatterWidth) {
  console.log("GO GO ", n);
  //var scatters = getRandomNumbers(300, -(scatterWidth/2), (scatterWidth/2));
  //console.log("scatters", scatters);
  for (var i = 0; i < (n || 1); i++) {
    var r1 = Math.floor(Math.random() * (scatterWidth / 2 - -scatterWidth / 2) + -scatterWidth / 2);
    var r2 = Math.floor(Math.random() * (scatterWidth / 2 - -scatterWidth / 2) + -scatterWidth / 2);
    this.boids.push(new Boid(this, col, speed, size, r1, r2));
  }
};

Swarm.prototype.scatterBoids = function () {};

Swarm.prototype.clear = function () {
  this.boids = [];
};

Swarm.prototype.getBoids = function () {
  return this.boids;
};

//Swarm.prototype.updateCentre

Object.defineProperty(Swarm.prototype, 'width', { get: function get() {
    return this.bounds.width;
  } });

Object.defineProperty(Swarm.prototype, 'height', { get: function get() {
    return this.bounds.height;
  } });

Object.defineProperty(Swarm.prototype, 'offsetx', { get: function get() {
    return this.offset.x;
  } });

Object.defineProperty(Swarm.prototype, 'offsety', { get: function get() {
    return this.offset.y;
  } });

Swarm.step = function (swarm) {
  var ctx = swarm;
  /*if (ctx.canvas.width != window.innerWidth)
    ctx.canvas.width = window.innerWidth;
  if (ctx.canvas.height != window.innerHeight)
    ctx.canvas.height = window.innerHeight;
  ctx.fillStyle = 'white';
  ctx.fillRect(0, 0, swarm.width, swarm.height);*/

  for (var i = 0; i < swarm.boids.length; i++) {
    swarm.boids[i].step(swarm);
    swarm.boids[i].draw(ctx);
  }
};

function getRandomNumbers(n, lower, upper) {

  console.log("n", n);
  var limit = 10,
      amount = n,
      lower_bound = lower,
      upper_bound = upper,
      unique_random_numbers = [];

  if (amount > limit) limit = amount; //Infinite loop if you want more unique
  //Natural numbers than existemt in a
  // given range
  while (unique_random_numbers.length < limit) {
    var random_number = Math.floor(Math.random() * (upper_bound - lower_bound) + lower_bound);
    if (unique_random_numbers.indexOf(random_number) == -1) {
      // Yay! new random number
      unique_random_numbers.push(random_number);
    }
  }

  return unique_random_numbers;
};

/* Test */

/*var swarm; // defined globally for skewer
$(document).ready(function() {
  swarm = new Swarm($('#canvas').get(0).getContext('2d'));
  swarm.id = setInterval(swarm.animate, 33);
  swarm.animate();
  swarm.clear();
  swarm.createBoid(200);
});*/
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/hello.html","");
$templateCache.put("app/components/fluxioLogo/filters.html","\r\n\r\n  <filter id=\"goo\">\r\n    <fegaussianblur in=\"SourceGraphic\" stddeviation=\"40\" result=\"blur\">\r\n    <fecolormatrix in=\"blur\" mode=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 50 -20\" result=\"goo\">\r\n    <feblend in=\"SourceGraphic\" in2=\"goo\">\r\n  </filter>\r\n  <filter id=\"goo-hd\">\r\n    <fegaussianblur in=\"SourceGraphic\" stddeviation=\"9\" result=\"blur\">\r\n    <fecolormatrix in=\"blur\" mode=\"matrix\" values=\"1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 30 -15\" result=\"goo\">\r\n    <fecomposite in=\"SourceGraphic\" in2=\"goo\" operator=\"atop\">\r\n  </filter>\r\n  <filter id=\"glitch\">\r\n    <feflood flood-color=\"#EEEEEE\" result=\"black\">\r\n    <feflood flood-color=\"lightgreen\" result=\"flood1\">\r\n    <feflood flood-color=\"lightblue\" result=\"flood2\">\r\n    <feoffset in=\"SourceGraphic\" dx=\"3\" dy=\"0\" result=\"off1a\">\r\n    <feoffset in=\"SourceGraphic\" dx=\"2\" dy=\"0\" result=\"off1b\">\r\n    <feoffset in=\"SourceGraphic\" dx=\"-3\" dy=\"0\" result=\"off2a\">\r\n    <feoffset in=\"SourceGraphic\" dx=\"-2\" dy=\"0\" result=\"off2b\">\r\n    <fecomposite in=\"flood1\" in2=\"off1a\" operator=\"in\" result=\"comp1\">\r\n    <fecomposite in=\"flood2\" in2=\"off2a\" operator=\"in\" result=\"comp2\">\r\n\r\n    <femerge x=\"0\" width=\"100%\" result=\"merge1\">\r\n      <femergenode in=\"black\">\r\n      <femergenode in=\"comp1\">\r\n      <femergenode in=\"off1b\">\r\n\r\n      <animate attributename=\"y\" id=\"y\" dur=\"4s\" values=\"104px; 104px; 30px; 105px; 30px; 2px; 2px; 50px; 40px; 105px; 105px; 20px; 6ßpx; 40px; 104px; 40px; 70px; 10px; 30px; 104px; 102px\" keytimes=\"0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1\" repeatcount=\"indefinite\">\r\n\r\n      <animate attributename=\"height\" id=\"h\" dur=\"4s\" values=\"10px; 0px; 10px; 30px; 50px; 0px; 10px; 0px; 0px; 0px; 10px; 50px; 40px; 0px; 0px; 0px; 40px; 30px; 10px; 0px; 50px\" keytimes=\"0; 0.362; 0.368; 0.421; 0.440; 0.477; 0.518; 0.564; 0.593; 0.613; 0.644; 0.693; 0.721; 0.736; 0.772; 0.818; 0.844; 0.894; 0.925; 0.939; 1\" repeatcount=\"indefinite\">\r\n    </femerge>\r\n\r\n\r\n    <femerge x=\"0\" width=\"100%\" y=\"60px\" height=\"65px\" result=\"merge2\">\r\n      <femergenode in=\"black\">\r\n      <femergenode in=\"comp2\">\r\n      <femergenode in=\"off2b\">\r\n\r\n      <animate attributename=\"y\" id=\"y\" dur=\"4s\" values=\"103px; 104px; 69px; 53px; 42px; 104px; 78px; 89px; 96px; 100px; 67px; 50px; 96px; 66px; 88px; 42px; 13px; 100px; 100px; 104px;\" keytimes=\"0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513; 0.548; 0.577; 0.613; 1\" repeatcount=\"indefinite\">\r\n\r\n      <animate attributename=\"height\" id=\"h\" dur=\"4s\" values=\"0px; 0px; 0px; 16px; 16px; 12px; 12px; 0px; 0px; 5px; 10px; 22px; 33px; 11px; 0px; 0px; 10px\" keytimes=\"0; 0.055; 0.100; 0.125; 0.159; 0.182; 0.202; 0.236; 0.268; 0.326; 0.357; 0.400; 0.408; 0.461; 0.493; 0.513;  1\" repeatcount=\"indefinite\">\r\n    </femerge>\r\n\r\n    <femerge>\r\n      <femergenode in=\"SourceGraphic\">\r\n\r\n      <femergenode in=\"merge1\">\r\n      <femergenode in=\"merge2\">\r\n\r\n    </femerge>\r\n  </filter>\r\n\r\n\r\n");
$templateCache.put("app/components/fluxioLogo/fluxioLogo.html","<div class=\"viewport\" scroll-watch=\"{from: 0, to: -1, stage: \'viewport\'}\" sw-broadcast=\"{\r\n       $rootScope: true,\r\n      \'revealHeader\': \'$positive > 24\'\r\n    }\" sw-stage=\"viewport\">\r\n\r\n\r\n<div class=\"fluxioLogoPositioner limit headerReveal\" ng-class=\"{\'reveal\': $ctrl.reveal}\" data-fluxio-header-reveal data-reveal-on=\"$ctrl.reveal\">\r\n  <fluxio-logo-svg class=\"fluxioLogoWrapper\"></fluxio-logo-svg>\r\n  <div class=\"revealButton\" ng-click=\"$ctrl.revealContent()\" ng-class=\"{\'hidden\': $ctrl.reveal}\">\r\n    <p>Read about us..</p>\r\n  </div>\r\n</div>\r\n\r\n  <div class=\"limit\">\r\n    <div class=\"typeset type\">\r\n      <div class=\"sectionWrapper\"><section>\r\n        <h2 class=\"headline\">comprehend | create | innovate</h2>\r\n        <h3 class=\"tagline\">Working with corporations, businesses and individuals</h3>\r\n        <p><strong>fluxio</strong> is a digital technology and design partnership.\r\n          We focus on two key areas: branding & identity\r\n          design, and website development & management\r\n          systems.</p>\r\n        <p>We strive to understand our customers and their\r\n          target audiences, and in turn create innovative\r\n          products that enhance engagement between them.</p>\r\n        <p>Together, we’ve been designing & developing solutions,\r\n          both on and off screen, for the past 5 years.</p>\r\n      </section></div>\r\n      <div class=\"sectionWrapper\"><section>\r\n        <h2 class=\"sectionTitle\">Websites</h2>\r\n        <div class=\"cols-2\">\r\n          <div class=\"col1\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\" ng-repeat=\"sector in $ctrl.sectorsLeft\">\r\n                <h3 class=\"sectionSub\">{{sector.title}}</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"client in sector.clients\">\r\n                    <a href=\"{{client.link}}\" target=\"_blank\"><span>{{client.name}}</span></a>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col2\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\" ng-repeat=\"sector in $ctrl.sectorsRight\">\r\n                <h3 class=\"sectionSub\">{{sector.title}}</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"client in sector.clients\">\r\n                    <a href=\"{{client.link}}\" target=\"_blank\"><span>{{client.name}}</span></a>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section></div>\r\n      <div class=\"sectionWrapper\"><section>\r\n        <h2 class=\"sectionTitle\">Logos</h2>\r\n        <p></p>\r\n        <div class=\"logoListWrapper\">\r\n          <ul class=\"logoList\">\r\n            <li class=\"logoItem\" ng-repeat=\"logosrc in $ctrl.logos\">\r\n              <div class=\"logoInner\">\r\n                <div class=\"logoContainer\">\r\n                  <div class=\"logoWrapper\">\r\n                    <div class=\"logo\">\r\n                      <img ng-src=\"{{\'assets/\' + logosrc}}\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </section></div>\r\n      <div class=\"sectionWrapper\"><section>\r\n        <h2 class=\"sectionTitle\">Fields of work</h2>\r\n        <div class=\"cols-2\">\r\n          <div class=\"col1\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\">\r\n                <h3 class=\"sectionSub\">Design</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"field in $ctrl.fields_design\">\r\n                    <span>{{field}}</span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col2\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\">\r\n                <h3 class=\"sectionSub\">Development</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"field in $ctrl.fields_technology\">\r\n                    <span>{{field}}</span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section></div>\r\n      <div class=\"sectionWrapper\"><section>\r\n        <h2 class=\"sectionTitle\">Technology</h2>\r\n        <div class=\"cols-2\">\r\n          <div class=\"col1\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\">\r\n                <h3 class=\"sectionSub\">Packages & environments</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"field in $ctrl.fields_environments\">\r\n                    <span>{{field}}</span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col2\">\r\n            <div class=\"colInner\">\r\n              <div class=\"entry\">\r\n                <h3 class=\"sectionSub\">Frameworks we use</h3>\r\n                <ul class=\"regList\">\r\n                  <li ng-repeat=\"field in $ctrl.fields_frameworks\">\r\n                    <span>{{field}}</span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </section></div>\r\n      <div class=\"sectionWrapper\">\r\n        <section>\r\n          <h2 class=\"sectionTitle\">Contact Us</h2>\r\n          <p>Call - 07772572233</p>\r\n          <p>E-mail - hello@fluxio.uk</p>\r\n          <p>Twitter - @CosyStudios</p>\r\n          <h3 class=\"sectionSub\">Drop In</h3>\r\n          <p>Our office is:</p>\r\n          <p>\r\n            The George,<br>\r\n            29 Mt Ephraim,<br>\r\n            Tunbridge Wells, Kent.<br>\r\n            TN4 8AA.\r\n          </p>\r\n        </section>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n");
$templateCache.put("app/components/fluxioLogo/fluxioLogoSvg.html","\r\n<svg ng-class=\"{\'loaded\': logoCtrl.loaded}\" id=\"logo\">\r\n</svg>\r\n");
$templateCache.put("app/components/fluxioHold/fluxioHold.html","<div class=\"viewport\">\n  <div class=\"fluxioLogoPositioner\">\n    <!--<fluxio-logo-svg class=\"fluxioLogoWrapper\"></fluxio-logo-svg>-->\n    <img class=\"fluxioLogoWrapper\" ng-src=\"app/components/fluxioLogo/fluxio-logo-svg.svg\">\n  </div>\n\n  <div class=\"typeset type show-grid\">\n    <h2 class=\"headline\">From the birth of an idea, to world wide implementation</h2>\n    <p>Fluxio are a graphic design, media & web development company.</p>\n    <p>This is just a holding space while we pull ourselves together.</p>\n    <h3>Some of our latest work</h3>\n    <p>Bill</p>\n    <p>Social Pantry</p>\n    <p>The Gin Box</p>\n    <p>The Poet</p>\n    <h2>Good afternoon</h2>\n    <p>Fluxio are graphic design, media & web development company.</p>\n    <p>This is just a holding space while we pull ourselves together.</p>\n    <h3>Some of our latest work</h3>\n    <p>Bill</p>\n    <p>Social Pantry</p>\n    <p>The Gin Box</p>\n    <p>The Poet</p>\n  </div>\n</div>\n");
$templateCache.put("app/components/screensaver/screensave.html","<div class=\"viewport ss-vp\">\n  <div class=\"screensaverPositioner\">\n    <fluxio-logo-screensave class=\"fluxioLogoWrapper\"></fluxio-logo-screensave>\n  </div>\n</div>\n");}]);
'use strict';

angular.module('app').config(routesConfig).run(function ($rootScope, $state, $stateParams) {
  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;
});

/** @ngInject */
function routesConfig($locationProvider, $stateProvider, $urlRouterProvider, $touchProvider, cfpLoadingBarProvider) {
  //$locationProvider.html5Mode(true).hashPrefix('!');
  $touchProvider.ngClickOverrideEnabled(true);

  cfpLoadingBarProvider.includeSpinner = false;
  //cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
  cfpLoadingBarProvider.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="pegl"></div><div class="pegr"></div></div></div>';

  $urlRouterProvider.otherwise('/');

  $stateProvider.state('holding', {
    url: '/',
    component: 'fluxioLogo'
  }).state('screensaver', {
    url: '/screensaver',
    component: 'screensave'
  });
}